import React, { forwardRef, memo } from 'react';
import shallowEqual from 'shallowequal';
import { areSectionsEqual } from '../shared/sectionsWithCounters';

export const isLayoutPropsEqual = (prev, next) => {
  const propsEqual = shallowEqual(
    {
      ...prev,
      sections: null,
    },
    {
      ...next,
      sections: null,
    }
  );

  return propsEqual && areSectionsEqual(prev.sections, next.sections);
};

export default (Component) =>
  memo(
    forwardRef((props, ref) => {
      return <Component {...props} ref={ref} />;
    }),
    isLayoutPropsEqual
  );
